import React from 'react'

// Import styles
import '../../App.css';
import '../../styles/Footer/footer.css'

// Import pictures
import bgBig from '../../resources/Footer/bg-big.svg';
import panel from '../../resources/Footer/panel.svg';
import kronnLogo from '../../resources/Footer/kronn-logo.svg';
import github from '../../resources/Footer/github.svg';
import facebook from '../../resources/Footer/facebook.svg';
import linkedId from '../../resources/Footer/linked-in.svg';
import telegram from '../../resources/Footer/telegram.svg';
import twitter from '../../resources/Footer/twitter.svg';
import reddit from '../../resources/Footer/reddit.svg';
import youtube from '../../resources/Footer/youtube.svg';

export default class Footer extends React.Component{
    render(){
        return(
            <div className='footer__outer-container'>
                <div className='footer__panel'>
                    <div className='footer__panel-contents'>
                        <div className='footer__panel-column'>
                            <div className='footer__title'>Excited about Kronn?</div>
                            <div className='text'>Stay up to date by signing up to our newsletter</div>
                        </div>
                        <div className='footer__panel-column-right'>
                            <input type="text" name="fname" autocomplete="off" placeholder="your email address" className='footer__text-input' />
                            <input type="submit" value='' className='footer__text-input-button' />
                            <div className='footer__text-input-shade' />
                        </div>
                    </div>

                    <img src={panel} className='footer__panel-image' />
                </div>

                <section className='footer__container'>
                    <div className='footer__text-column'>
                        <img src={kronnLogo} className='footer__kronn-logo' />
                        <div style={{marginTop: 20}} className='text footer__text'>KRONN VENTURES AG</div>
                        <div className='text footer__text'>KRONN HAUSE,</div>
                        <div className='text footer__text'>Hintermettlen 12, CH,</div>
                        <div className='text footer__text'>6318 Walchwil</div>
                        <div className='text footer__text'>Zug Switzerland</div>
                    </div>

                    <div className='footer__text-column'>
                        <div className='text footer__text'>Sitemap</div>
                        <div style={{marginTop: 20}} className='text footer__text'>Home</div>
                        <div className='text footer__text'>Exchange to fiat</div>
                        <div className='text footer__text'>Kronn bank</div>
                        <div className='text footer__text'>Get a share</div>
                        <div className='text footer__text'>Our roadmap</div>
                        <div className='text footer__text'>Community</div>
                    </div>

                    <div className='footer__text-column'>
                        <div className='text footer__text'>Social</div>

                        <div className='footer__social-icons-container'>
                            <div className='footer__social-row'>
                                <a href='#'><img src={github} className='footer__social-icon' /></a>
                                <a href='#'><img src={facebook} className='footer__social-icon' /></a>
                                <a href='#'><img src={linkedId} className='footer__social-icon' /></a>
                                <a href='#'><img src={telegram} className='footer__social-icon' /></a>
                            </div>
                            <div className='footer__social-row' style={{width: 181}}>
                                <a href='#'><img src={twitter} className='footer__social-icon' /></a>
                                <a href='#'><img src={reddit} className='footer__social-icon' /></a>
                                <a href='https://www.youtube.com/channel/UCp9eqm5OkMsLFIblSvSf8vg'><img src={youtube} className='footer__social-icon' /></a>
                            </div>
                        </div>
                    </div>
                </section>

                <img src={bgBig} className='footer__bg-image' />
                <div className='footer__addition' />

                <div className='text footer__copyright-text' style={{fontSize: 10}}>
                    COPYRIGHT © 2018 KRONN.NET ALL RIGHTS RESERVED.
                </div>
            </div>


        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js